/* src/app/shared/contract/contract-item/contract-general-informations/contract-advertiser-informations/contract-advertiser-informations.component.scss */
.category-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;
}
.data-container {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
.data-title {
  display: flex;
  gap: 5px;
  background-color: rgba(107, 144, 179, 0.05);
  font: 400 15px FranceTV Brown;
  color: #6B90B3;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
}
.error {
  padding: 10px;
}
/*# sourceMappingURL=contract-advertiser-informations.component.css.map */
